import { ClinicModel, IModel, Model, ModelRecord } from "@common/models";
import { DateTime } from "luxon";

export interface IReservation extends IModel {
	reservationId: number;
	clinicId: number;
	speciesId: number;
	clientId?: number | undefined;
	petId?: number | undefined;
	reservedDate: string;
	confirmationDate?: string | undefined;
	startDate: string;
	endDate: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone1: string;
	petName: string;
	sourceSystemKey: string;
	wasPriorCustomer: boolean;
	cancellationDate?: string | undefined;
	confirmation1SMSDate?: string | undefined;
	confirmation2SMSDate?: string | undefined;
	confirmation3SMSDate?: string | undefined;
	isHidden: boolean;
	source: string;
	preVisitSMSDate?: string | undefined;
	preVisitSMSResponseDate?: string | undefined;
	preVisitSMSResponse?: boolean | undefined;
	addedToCalendar: boolean;
	rebooked: boolean;
	bookingSMSDate?: string | undefined;
	clinic?: ClinicModel;
	species?: any; // SpeciesModel;
	client?: any; // ClientModel;
	pet?: any; // PetModel;
	intakeId?: number | undefined;
	intakeResponseCompleteDate?: string | undefined;
	intakePetId?: number | undefined;
	intakePetResponseCompleteDate?: string | undefined;
	intakePublicId?: string | undefined;
	clinicCancellationProcessedDate?: string | undefined;
	reservationPublicId?: string | undefined;
	hasVisit: boolean;
	highRiskDate?: string | undefined;
	highRiskProcessedDate?: string | undefined;
	reservationAssignmentStatusId?: number | undefined;
	canSMS?: boolean | undefined;
	canSMSDateUpdated?: string | undefined;
	canSMSUserUpdated?: string | undefined;
	canCall?: boolean | undefined;
	canCallDateUpdated?: string | undefined;
	canCallUserUpdated?: string | undefined;
}

export class VisitReservationModel extends Model implements ModelRecord<IReservation> {
	reservationId: number;
	clinicId: number;
	speciesId: number;
	clientId: number | undefined;
	petId: number | undefined;
	reservedDate: DateTime;
	confirmationDate: DateTime | undefined;
	startDate: DateTime;
	endDate: DateTime;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone1: string;
	petName: string;
	sourceSystemKey: string;
	wasPriorCustomer: boolean;
	cancellationDate: DateTime | undefined;
	confirmation1SMSDate: DateTime | undefined;
	confirmation2SMSDate: DateTime | undefined;
	confirmation3SMSDate: DateTime | undefined;
	isHidden: boolean;
	source: string;
	preVisitSMSDate: DateTime | undefined;
	preVisitSMSResponseDate: DateTime | undefined;
	preVisitSMSResponse: boolean | undefined;
	addedToCalendar: boolean;
	rebooked: boolean;
	bookingSMSDate: DateTime | undefined;
	clinic: any; // ClinicModel;
	species: any; // SpeciesModel;
	client: any; // ClientModel;
	pet: any; // PetModel;
	intakeId: number | undefined;
	intakeResponseCompleteDate: DateTime | undefined;
	intakePetId: number | undefined;
	intakePetResponseCompleteDate: DateTime | undefined;
	intakePublicId: string | undefined;
	clinicCancellationProcessedDate: DateTime | undefined;
	reservationPublicId: string | undefined;
	hasVisit: boolean;
	highRiskDate: DateTime | undefined;
	highRiskProcessedDate: DateTime | undefined;
	reservationAssignmentStatusId: number | undefined;
	canSMS: boolean | undefined;
	canSMSDateUpdated: DateTime | undefined;
	canSMSUserUpdated: string | undefined;
	canCall: boolean | undefined;
	canCallDateUpdated: DateTime | undefined;
	canCallUserUpdated: string | undefined;

	constructor(params: Partial<IReservation>) {
		super(params);
		this.reservationId = _.defaultTo(params.reservationId, 0);
		this.clinicId = _.defaultTo(params.clinicId, 0);
		this.speciesId = _.defaultTo(params.speciesId, 0);
		this.clientId = _.defaultTo(params.clientId, undefined);
		this.petId = _.defaultTo(params.petId, undefined);

		this.reservedDate = DateTime.fromISO(_.defaultTo(params.reservedDate, "2000-01-01"), { zone: "utc" });
		this.confirmationDate = DateTime.fromISO(_.defaultTo(params.confirmationDate, "2000-01-01"), { zone: "utc" });
		this.startDate = DateTime.fromISO(_.defaultTo(params.startDate, "2000-01-01"), { zone: "utc" });
		this.endDate = DateTime.fromISO(_.defaultTo(params.endDate, "2000-01-01"), { zone: "utc" });

		this.firstName = _.defaultTo(params.firstName, "");
		this.lastName = _.defaultTo(params.lastName, "");
		this.emailAddress = _.defaultTo(params.emailAddress, "");
		this.phone1 = _.defaultTo(params.phone1, "");
		this.petName = _.defaultTo(params.petName, "");
		this.sourceSystemKey = _.defaultTo(params.sourceSystemKey, "");
		this.wasPriorCustomer = _.defaultTo(params.wasPriorCustomer, false);

		this.cancellationDate = params.cancellationDate ? DateTime.fromISO(params.cancellationDate, { zone: "utc" }) : undefined;
		this.confirmation1SMSDate = DateTime.fromISO(_.defaultTo(params.confirmation1SMSDate, "2000-01-01"), { zone: "utc" });
		this.confirmation2SMSDate = DateTime.fromISO(_.defaultTo(params.confirmation2SMSDate, "2000-01-01"), { zone: "utc" });
		this.confirmation3SMSDate = DateTime.fromISO(_.defaultTo(params.confirmation3SMSDate, "2000-01-01"), { zone: "utc" });

		this.isHidden = _.defaultTo(params.isHidden, false);
		this.source = _.defaultTo(params.source, "");

		this.preVisitSMSDate = DateTime.fromISO(_.defaultTo(params.preVisitSMSDate, "2000-01-01"), { zone: "utc" });
		this.preVisitSMSResponseDate = DateTime.fromISO(_.defaultTo(params.preVisitSMSResponseDate, "2000-01-01"), { zone: "utc" });

		this.preVisitSMSResponse = _.defaultTo(params.preVisitSMSResponse, undefined);
		this.addedToCalendar = _.defaultTo(params.addedToCalendar, false);
		this.rebooked = _.defaultTo(params.rebooked, false);

		this.bookingSMSDate = DateTime.fromISO(_.defaultTo(params.bookingSMSDate, "2000-01-01"), { zone: "utc" });

		this.clinic = params.clinic; // ?: ClinicModel;
		this.species = params.species; // ?: any; // SpeciesModel;
		this.client = params.client; // ?: any; // ClientModel;
		this.pet = params.pet; // ?: any; // PetModel;

		this.intakeId = _.defaultTo(params.intakeId, undefined);
		this.intakeResponseCompleteDate = DateTime.fromISO(_.defaultTo(params.intakeResponseCompleteDate, "2000-01-01"), { zone: "utc" });
		this.intakePetId = _.defaultTo(params.intakePetId, undefined);
		this.intakePetResponseCompleteDate = DateTime.fromISO(_.defaultTo(params.intakePetResponseCompleteDate, "2000-01-01"), { zone: "utc" });
		this.intakePublicId = _.defaultTo(params.intakePublicId, undefined);
		this.clinicCancellationProcessedDate = DateTime.fromISO(_.defaultTo(params.clinicCancellationProcessedDate, "2000-01-01"), { zone: "utc" });
		this.reservationPublicId = _.defaultTo(params.reservationPublicId, undefined);
		this.hasVisit = _.defaultTo(params.hasVisit, false);
		this.highRiskDate = DateTime.fromISO(_.defaultTo(params.highRiskDate, "2000-01-01"), { zone: "utc" });
		this.highRiskProcessedDate = DateTime.fromISO(_.defaultTo(params.highRiskProcessedDate, "2000-01-01"), { zone: "utc" });
		this.reservationAssignmentStatusId = _.defaultTo(params.reservationAssignmentStatusId, undefined);

		this.canSMS = _.defaultTo(params.canSMS, undefined);
		this.canSMSDateUpdated = DateTime.fromISO(_.defaultTo(params.canSMSDateUpdated, "2000-01-01"), { zone: "utc" });
		this.canSMSUserUpdated = _.defaultTo(params.canSMSUserUpdated, undefined);

		this.canCall = _.defaultTo(params.canCall, undefined);
		this.canCallDateUpdated = DateTime.fromISO(_.defaultTo(params.canCallDateUpdated, "2000-01-01"), { zone: "utc" });
		this.canCallUserUpdated = _.defaultTo(params.canCallUserUpdated, undefined);
	}
}
